import Vue from 'vue'
//import fb from 'firebase'

export default {
	state: {
		articles: [],
	},
	mutations: {
		loadArticles (state, payload) {
			state.articles = payload
		},
		
	},
	actions: {
		async fetchArticles ({commit}) {
			
			commit('clearError')
			commit('setLoading', true)

			const res = []
			
			try {
				const articles = await Vue.$db.collection('news')
                .orderBy("date", "desc")
				.get()

				if (articles) {
					articles.forEach(doc => {
						const art = doc.data()
                        art.id = doc.id;
						res.push({...art, date: art.date.toDate()});
					})
				}
				commit('setLoading', false)
				commit('loadArticles', res)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		
	},
	getters: {
		articles (state) {
			return state.articles
		}
	}
}